import type { DatasetZoomButtonProps } from "./dataset-zoom-button.type";

import { ExpandOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import { useDatasetsMutatorDatasetTypeStatus } from "@/modules/datasets/datasets-mutator";

const DatasetZoomButton = ({
  datasetType,
  loading,
  ...buttonProps
}: DatasetZoomButtonProps) => {
  const { t } = useTranslation();
  const { isSaving, toBeDeleted } =
    useDatasetsMutatorDatasetTypeStatus(datasetType);

  if (loading || isSaving || toBeDeleted) return null;

  return (
    <Tooltip title={t("dataset:zoom.openModal")}>
      <Button {...buttonProps} icon={<ExpandOutlined />} />
    </Tooltip>
  );
};

export default DatasetZoomButton;
